import { Button, ButtonGroup, Flex, Spinner, Steps } from "@chakra-ui/react";

import { STEPS } from "@features/services/travel/types";

const TravelFormNavigation = ({
  step,
  canAdvance,
  submitting,
  onNext,
  onFinish,
}: {
  step: number;
  canAdvance: boolean;
  submitting: boolean;
  onNext: () => void;
  onFinish: () => void;
}) => (
  <Flex
    mt={8}
    pt={4}
    borderTopWidth="1px"
    borderColor="border.dark"
    justify="space-between"
    gap={4}
  >
    <ButtonGroup size="sm" variant="outline">
      {step > 0 && (
        <Steps.PrevTrigger asChild>
          <Button borderColor="border.dark">Previous</Button>
        </Steps.PrevTrigger>
      )}
      {step < STEPS.length - 1 && (
        <Button borderColor="border.dark" onClick={onNext}>
          Next
        </Button>
      )}
    </ButtonGroup>
    {step === STEPS.length - 1 && (
      <Button onClick={onFinish} disabled={!canAdvance || submitting}>
        {submitting ? <Spinner size="sm" /> : "Finish"}
      </Button>
    )}
  </Flex>
);

export default TravelFormNavigation;
